import { toaster } from "../components/toaster";
import { DefaultService } from "../generated";
import { useMutation } from "@tanstack/react-query";

export const useUnsubscribeEmail = (token: string) => {
  return useMutation({
    mutationKey: ["unsubscribeEmail"],
    mutationFn: () =>
      DefaultService.fakturEmailsViewsUnsubscribeEmail({
        token,
      }),
    onSuccess: () => {
      toaster.success({ title: "E-post er avregistrert!" });
    },
  });
};
